/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Born_Gross_Iguana_BeamInputs */

const fr_born_gross_iguana_beam = /** @type {(inputs: Born_Gross_Iguana_BeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séance mis à jour`)
};

/**

* @param {Born_Gross_Iguana_BeamInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const born_gross_iguana_beam = /** @type {((inputs?: Born_Gross_Iguana_BeamInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Born_Gross_Iguana_BeamInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_born_gross_iguana_beam(inputs)
});